<template>
  <svg class="mx-checked-mark" aria-hidden="true" viewBox="0 0 1024 1024">
    <path d="M129.3,428.6L52,512l345,372.5l575-620.8l-69.5-75L400.4,718.2L129.3,428.6z"></path>
  </svg>
</template>